/**
 * ETTLI localStorage Wishlist
 * Speichert Wishlist-Daten im Browser localStorage
 */

(function() {
  'use strict';

  var STORAGE_KEY = 'ettli_wishlist';

  // Wishlist Manager
  window.EttliWishlist = {

    // Alle Wishlist-Items holen
    getItems: function() {
      try {
        var data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Wishlist: Error reading from localStorage', e);
        return [];
      }
    },

    // Wishlist speichern
    saveItems: function(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.updateCounter();
        this.dispatchEvent('wishlist:updated', { items: items });
      } catch (e) {
        console.error('Wishlist: Error saving to localStorage', e);
      }
    },

    // Pruefen ob Produkt in Wishlist ist
    hasItem: function(productId) {
      var items = this.getItems();
      var id = parseInt(productId, 10);
      for (var i = 0; i < items.length; i++) {
        if (parseInt(items[i].id, 10) === id) {
          return true;
        }
      }
      return false;
    },

    // Produkt zur Wishlist hinzufuegen
    addItem: function(product) {
      if (this.hasItem(product.id)) {
        return false;
      }

      var items = this.getItems();
      items.push({
        id: parseInt(product.id, 10),
        handle: product.handle,
        title: product.title,
        price: product.price,
        comparePrice: product.comparePrice || null,
        image: product.image,
        url: product.url,
        available: product.available !== false && product.available !== 'false',
        variantId: product.variantId,
        addedAt: new Date().toISOString()
      });

      this.saveItems(items);
      this.dispatchEvent('wishlist:added', { product: product });
      return true;
    },

    // Produkt aus Wishlist entfernen
    removeItem: function(productId) {
      var items = this.getItems();
      var id = parseInt(productId, 10);
      var filtered = [];

      for (var i = 0; i < items.length; i++) {
        if (parseInt(items[i].id, 10) !== id) {
          filtered.push(items[i]);
        }
      }

      if (filtered.length !== items.length) {
        this.saveItems(filtered);
        this.dispatchEvent('wishlist:removed', { productId: productId });
        return true;
      }
      return false;
    },

    // Wishlist toggle (hinzufuegen oder entfernen)
    toggleItem: function(product) {
      if (this.hasItem(product.id)) {
        this.removeItem(product.id);
        return false;
      } else {
        this.addItem(product);
        return true;
      }
    },

    // Anzahl der Items
    getCount: function() {
      return this.getItems().length;
    },

    // Wishlist leeren
    clear: function() {
      this.saveItems([]);
      this.dispatchEvent('wishlist:cleared');
    },

    // Counter im Header aktualisieren
    updateCounter: function() {
      var count = this.getCount();
      var counters = document.querySelectorAll('.wishlist-count, .js-wishlist-count');

      for (var i = 0; i < counters.length; i++) {
        counters[i].textContent = count;
        counters[i].style.display = count > 0 ? '' : 'none';
      }
    },

    // Button-States aktualisieren
    updateButtons: function() {
      var self = this;
      var buttons = document.querySelectorAll('[data-wishlist-toggle]');

      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var productId = parseInt(btn.getAttribute('data-product-id'), 10);
        var isInWishlist = self.hasItem(productId);

        // Klassen setzen/entfernen
        if (isInWishlist) {
          btn.classList.add('is-active');
          btn.classList.add('added');
        } else {
          btn.classList.remove('is-active');
          btn.classList.remove('added');
        }

        // Aria-Label und Title aktualisieren
        var label = isInWishlist ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufuegen';
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', isInWishlist ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste');

        // Icons umschalten
        var iconDefault = btn.querySelector('.wishlist-icon-default');
        var iconActive = btn.querySelector('.wishlist-icon-active');

        if (iconDefault) {
          iconDefault.style.display = isInWishlist ? 'none' : '';
        }
        if (iconActive) {
          iconActive.style.display = isInWishlist ? 'flex' : 'none';
        }
      }
    },

    // Custom Event dispatchen
    dispatchEvent: function(name, detail) {
      var event;
      if (typeof CustomEvent === 'function') {
        event = new CustomEvent(name, { detail: detail || {} });
      } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(name, true, true, detail || {});
      }
      document.dispatchEvent(event);
    },

    // Initialisierung
    init: function() {
      this.updateCounter();
      this.updateButtons();
      this.bindEvents();
    },

    // Event Listeners binden
    bindEvents: function() {
      var self = this;

      // Event Delegation fuer Wishlist Toggle Buttons
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var productId = parseInt(btn.getAttribute('data-product-id'), 10);

        if (!productId) {
          console.error('Wishlist: Keine product-id gefunden!');
          return;
        }

        var productData = {
          id: productId,
          handle: btn.getAttribute('data-product-handle') || '',
          title: btn.getAttribute('data-product-title') || '',
          price: btn.getAttribute('data-product-price') || '0',
          comparePrice: btn.getAttribute('data-product-compare-price') || null,
          image: btn.getAttribute('data-product-image') || '',
          url: btn.getAttribute('data-product-url') || '/products/' + btn.getAttribute('data-product-handle'),
          available: btn.getAttribute('data-product-available') !== 'false',
          variantId: btn.getAttribute('data-variant-id') || ''
        };

        var wasAdded = self.toggleItem(productData);
        self.updateButtons();

        // Visuelles Feedback - Animation
        btn.classList.add('wishlist-animating');
        setTimeout(function() {
          btn.classList.remove('wishlist-animating');
        }, 300);
      });

      // Storage Event fuer Tab-Synchronisation
      window.addEventListener('storage', function(e) {
        if (e.key === STORAGE_KEY) {
          self.updateCounter();
          self.updateButtons();
        }
      });

      // Bei AJAX-Laden (Quick View, Collection Filter, etc.) Buttons aktualisieren
      if (typeof jQuery !== 'undefined') {
        jQuery('body').on('ajaxCart.afterCartLoad', function() {
          setTimeout(function() {
            self.updateButtons();
          }, 100);
        });
      }

      // MutationObserver fuer dynamisch geladene Inhalte
      if (typeof MutationObserver !== 'undefined') {
        var debounceTimer;
        var observer = new MutationObserver(function(mutations) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            self.updateButtons();
          }, 100);
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  };

  // Automatisch initialisieren wenn DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.EttliWishlist.init();
    });
  } else {
    window.EttliWishlist.init();
  }

})();
